import { useContext, useState } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';

import AuthContext from 'context/authContext';

import { useDonors } from 'hooks/useDonors';
import { useCreateOrder } from 'hooks/useStripePayments';
import { GIFT_AID_STATUS_UNCLAIMED } from 'components/gift-aid/unclaimed-transactions';

import { getRelativePath } from 'helpers/utils';
import paths from 'routes/paths';

import DonationConfig from 'components/add-donation/DonationConfig';
import { DonationPaymentPage } from 'components/add-donation/DonationPaymentPage';
import { Col, Row } from 'react-bootstrap';

function AddDonation() {
  const [data, setData] = useState({});

  const navigate = useNavigate();

  const { organization, selectedBranchId } = useContext(AuthContext);

  const { donors: donorsData } = useDonors();
  const { createOrderAsync, isCreating } = useCreateOrder();

  const onSubmitDonationConfig = async data => {
    const {
      donorId,
      donationItems,
      subtotal,
      transactionFees,
      total,
      settings
    } = data;

    const giftAidData = {
      data: {
        amount: total * 0.25,
        donar_id: donorId,
        status: GIFT_AID_STATUS_UNCLAIMED
      }
    };

    if (
      ['cash', 'bank_transfer', 'cheque', 'amember', 'direct_debit'].includes(
        data.paymentMethod
      )
    ) {
      const orderDetails = donationItems.map(
        ({
          amount,
          quantity = 1,
          values,
          type,
          packageId,
          donationLocationIds
        }) => ({
          amount: amount * quantity,
          billing_condition: values.billingCondition,
          donation_type_id: type?.id || type,
          package_id: packageId,
          location_id_list: donationLocationIds?.length
            ? donationLocationIds
            : null
        })
      );

      try {
        await createOrderAsync({
          donorId,
          branchId: selectedBranchId,
          orderDetails,
          paymentType: data.paymentMethod,
          subtotal,
          transactionFees: 0,
          donationAmount: total,
          giftAidEligible: settings.giftAid,
          giftAids: settings.giftAid ? giftAidData : null,
          paymentDate: data.paymentDate || undefined
        });
        navigate(paths.allDonations);
      } catch (err) {
        // Error toast handled by hook
      }
    } else {
      setData({
        donorId,
        donationItems,
        subtotal,
        transactionFees,
        total,
        settings,
        organization: organization.id,
        donorsData,
        giftAidData
      });
      navigate(paths.addDonationPayment);
    }
  };

  return (
    <Row className="pt-3 gx-3">
      <Col md={12}>
        <Routes>
          <Route
            path={getRelativePath(paths.addDonationConfig, paths.addDonation)}
            element={
              <DonationConfig
                onSubmit={onSubmitDonationConfig}
                loading={isCreating}
              />
            }
          />
          <Route
            path={getRelativePath(paths.addDonationPayment, paths.addDonation)}
            element={<DonationPaymentPage data={data} />}
          />
          <Route
            path={'/*'}
            element={
              <Navigate
                to={getRelativePath(paths.addDonationConfig, paths.addDonation)}
              />
            }
          />
        </Routes>
      </Col>
    </Row>
  );
}

export { AddDonation };
